import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Ingesta from "@/pages/Ingesta";
import Fuentes from "@/pages/Fuentes";
import Redaccion from "@/pages/Redaccion";
import Articulo from "@/pages/Articulo";
import Biblioteca from "@/pages/Biblioteca";
import Documentacion from "@/pages/Documentacion";
import { TourGuide } from "@/components/TourGuide";
import Difusion from "@/pages/Difusion";
import Banners from "@/pages/Banners";
import Suscriptores from "@/pages/Suscriptores";
import Boletines from "@/pages/Boletines";
import Medios from "@/pages/Medios";
import Ajustes from "@/pages/Ajustes";
import Equipo from "@/pages/Equipo";
import Suscribirse from "@/pages/Suscribirse";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground text-sm">
        Cargando sala de redacción…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/suscribirse" element={<Suscribirse />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/ingesta" element={<Protected><Ingesta /></Protected>} />
            <Route path="/fuentes" element={<Protected><Fuentes /></Protected>} />
            <Route path="/redaccion" element={<Protected><Redaccion /></Protected>} />
            <Route path="/redaccion/:id" element={<Protected><Articulo /></Protected>} />
            <Route path="/biblioteca" element={<Protected><Biblioteca /></Protected>} />
            <Route path="/documentacion" element={<Protected><Documentacion /></Protected>} />
            <Route path="/difusion" element={<Protected><Difusion /></Protected>} />
            <Route path="/banners" element={<Protected><Banners /></Protected>} />
            <Route path="/suscriptores" element={<Protected><Suscriptores /></Protected>} />
            <Route path="/boletines" element={<Protected><Boletines /></Protected>} />
            <Route path="/medios" element={<Protected><Medios /></Protected>} />
            <Route path="/ajustes" element={<Protected><Ajustes /></Protected>} />
            <Route path="/equipo" element={<Protected><Equipo /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <TourGuide />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
